import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Subscriber} from 'rxjs/Subscriber';

export enum Ng2LoadingBarEventType {
    PROGRESS,
    HEIGHT,
    COLOR,
    VISIBLE,
}

export class Ng2LoadingBarEvent {
    constructor(public type: Ng2LoadingBarEventType, public value: any) {
    }
}

@Injectable()
export class Ng2LoadingBarService {
    private startedCount: {[progressName: string]: number} = {};
    private intervalCounterIds: {[progressName: string]: number} = {};

    public subscribers: Array<Subscriber<Ng2LoadingBarEvent>> = [];
    public observable: Observable<Ng2LoadingBarEvent>;
    public interval: number = 100;

    constructor() {
        this.observable = new Observable<Ng2LoadingBarEvent>((subscriber: Subscriber<Ng2LoadingBarEvent>) => {
            this.subscribers.push(subscriber);
        });
    }

    setStartedCount(name: string, value: number) {
        this.startedCount[name] = value;
    }

    getStartedCount(name: string): number {
        if (this.startedCount.hasOwnProperty(name)) {
            return this.startedCount[name];
        } else {
            return 0;
        }
    }

    setIntervalId(name: string, value: any) {
        this.intervalCounterIds[name] = value;
    }

    getIntervalId(name: string): any {
        if (this.intervalCounterIds.hasOwnProperty(name)) {
            return this.intervalCounterIds[name];
        } else {
            return null;
        }
    }

    start(name: string = 'common') {
        this.setStartedCount(name, this.getStartedCount(name) + 1);

        if (this.getIntervalId(name) !== null) {
            return;
        }

        this.emitEvent(new Ng2LoadingBarEvent(Ng2LoadingBarEventType.VISIBLE, {
            value: true,
            name: name
        }));

        let progress: number = 1;
        let updateProgress = () => {
            this.emitEvent(new Ng2LoadingBarEvent(Ng2LoadingBarEventType.PROGRESS, {
                value: progress,
                name: name
            }));
            progress += -Math.log(progress / 100);
        };

        updateProgress();

        let intervalId: any = setInterval(updateProgress, this.interval);

        this.setIntervalId(name, intervalId);
    }


    complete(name: string = 'common') {
        if (this.getStartedCount(name) > 0) {
            this.setStartedCount(name, this.getStartedCount(name) - 1);
        } else {
            return;
        }

        if (this.getStartedCount(name) >= 1) {
            return;
        }

        clearInterval(this.getIntervalId(name));
        this.setIntervalId(name, null);

        this.emitEvent(new Ng2LoadingBarEvent(Ng2LoadingBarEventType.PROGRESS, {
            value: 100,
            name: name
        }));

        setTimeout(() => {
            this.emitEvent(new Ng2LoadingBarEvent(Ng2LoadingBarEventType.VISIBLE, {
                value: false,
                name: name
            }));
        }, 700);
    }


    public emitEvent(event: Ng2LoadingBarEvent) {
        if (this.subscribers.length) {
            for (let subscriber of this.subscribers) {
                subscriber.next(event);
            }
        }
    }
}


// WEBPACK FOOTER //
// /home3/usalinks/public_html/ally-book-source/src/app/services/loading-bar-service.ts